import Requests from './requests'
import { sprintf } from 'sprintf-js'

export default class Links extends Requests {

  in (relation = '', objectType = '', onlyIds = false) {
    return this._links('in', relation, objectType, onlyIds)
  }

  out (relation = '', objectType = '', onlyIds = false) {
    return this._links('out', relation, objectType, onlyIds)
  }

  get (relation, destinationType, destinationId) {
    let that = this
    return this._make(
      'get',
      that._url(relation, destinationType, destinationId),
      null,
      that._headerAuthorization(),
      {}
    ).then(that._getData)
  }

  create (relation, destinationType, destinationId, data = {}) {
    let that = this
    return this._make(
      'post',
      that._url(relation, destinationType, destinationId),
      data,
      that._headerAuthorization(),
      {}
    ).then(that._getData)
  }

  delete (relation, destinationType, destinationId) {
    let that = this
    return this._make(
      'delete',
      that._url(relation, destinationType, destinationId),
      null,
      that._headerAuthorization(),
      {}
    ).then(that._getData)
  }

  _links (direction, relation = '', objectType = '', onlyIds = false) {
    let params = {}
    if (objectType !== '') {
      params['type'] = objectType
    }
    if (onlyIds === true) {
      params['type'] = true
    }
    // let suffixes = []
    // if (objectType !== '') {
    //   suffixes.push(sprintf('type=%s', objectType))
    // }
    // if (onlyIds === true) {
    //   suffixes.push('ids=true')
    // }
    // add relation name to the url if especified
    if (relation !== '') {
      return this._getURL(sprintf('%s/%s', direction, relation), params)
    } else {
      return this._getURL(direction, params)
    }
  }

}



// WEBPACK FOOTER //
// ./src/links.js